module.exports = __webpack_public_path__ + "static/img/zip.cebc174d.png";